import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a543a6d8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a543a6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a543a6d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a543a6d8')) {
      api.createRecord('a543a6d8', component.options)
    } else {
      api.reload('a543a6d8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a543a6d8&scoped=true&", function () {
      api.rerender('a543a6d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classAdmin/index.vue"
export default component.exports